export default __webpack_public_path__ + "static/media/MTcarpaFull_LateralIzq.cf53feb0.webp";